import { Typography, Box, useTheme } from "@mui/material";
import { tokens } from "../theme";

const Header = ({title, subtitle}) => {
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    return <Box mb="30px">
        <Typography 
            varient="h2" 
            colors={colors.grey[100]}
            fontWeight="bold"
            sx={{ mb: "5px" }}
            >
                {title}
                </Typography>
        <Typography 
            varient="h5" 
            colors={colors.greenAccent[400]}
            fontWeight="bold"
            sx={{ mb: "5px" }}
            >
            {subtitle}
            </Typography>
    </Box>
}

export default Header;